import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import {
  default as CustomProvider,
} from "./_helper/customizer/CustomizerProvider";
import ProductProvider from "./_helper/ecommerce/product/ProductProvider";
import Routers from "./Routes";
import AuthProvider from "./_helper/Auth/AuthProvider";
import ProactiveAccessTokenRefresh from "./utils/hooks/ProactiveAccessTokenRefresh";
import IdleLogout from "./utils/hooks/IdleLogout";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from "@tanstack/react-query";
import { handleQueryClientError } from "./utils/globalErrorHandlers";
import ScrollToTop from "./ScrollToTop";
import HousingInspectionProvider from "./Pages/Makkah/HousingAndAccommodations/HousingInspectionContext/housingContext";
import { useEffect } from "react";
import { useRefreshCurrentUser } from "./utils/hooks/useRefreshCurrentUser";
import { ClientCache } from "./Pages/ClientCache";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1 * 60 * 1000,
      // Disable refetch on window focus globally
      refetchOnWindowFocus: false,
      // Disable retry globally
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: handleQueryClientError,
  }),
  mutationCache: new MutationCache({
    onError: handleQueryClientError,
  }),
});

function RefreshCurrentUserOnLoad() {
  const refreshCurrentUser = useRefreshCurrentUser();

  useEffect(() => {
    refreshCurrentUser();
    // Call /me once on full app load (browser refresh)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={"/"}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <ClientCache>
            <CustomProvider>
              <ProductProvider>
                <AnimationThemeProvider>
                  <ProactiveAccessTokenRefresh />
                  <IdleLogout />
                  <RefreshCurrentUserOnLoad />
                  <HousingInspectionProvider>
                    <ScrollToTop />
                    <Routers />
                  </HousingInspectionProvider>
                </AnimationThemeProvider>
              </ProductProvider>
            </CustomProvider>
          </ClientCache>
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
export default App;
